// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + chunkId + "." + {"10": "95a7cd2a","318": "0beb6826","48": "f8548674","57": "ec619445",}[chunkId] + ".css"
}